'use strict';

angular.module('internal.licenses')
    .controller('InternalLicensePackage', ['$scope', '$stateParams', 'FBPackages', '$state', 'Triggers', '$q', function ($scope, $stateParams, FBPackages, $state, Triggers, $q) {
        $scope.resetLicense();
        $scope.package = $stateParams.license_package;
        $scope.packageID = $stateParams.packageID;
        $scope.loading = true;
        $scope.saving = false;
        $scope.deleting = false;

        var promises = [];

        if ($stateParams.packageID != null) {
            promises.push(FBPackages.getByID($stateParams.packageID).then(function(license_package){
                $scope.package = license_package;
            }))
        }
        else {
            $scope.package = {};
            $scope.package.forms = [];
        }

        promises.push(Triggers.get().then(function (triggers) {
            triggers.unshift({ id: "00000000-0000-0000-0000-000000000000", name: "-- New Trigger --" });
            $scope.triggers = triggers;
        }));

        $q.all(promises).then(function () {
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });

        $scope.save = function () {
            $scope.saving = true;

            FBPackages.save({ form_package: $scope.package, license_id: $scope.licenseID }).then(function (license_package) {
                updateArray($scope.license.packages, license_package);
                updateArray($scope.masterLicense.packages, license_package);
                $scope.saving = false;
                $state.go('internal.licensing.license.forms.packages', { id: $scope.licenseID });
            });
        }

        $scope.delete = function () {
            $scope.deleting = true;

            if (window.confirm('Are you sure you want to delete this form package?')) {
                FBPackages.delete($stateParams.packageID).then(function () {
                    updateArray($scope.license.packages, $scope.package, true);
                    updateArray($scope.masterLicense.packages, $scope.package, true);
                    $scope.deleting = false;
                    $state.go('internal.licensing.license.forms.packages', { id: $scope.licenseID });
                })
            }
            else {
                $scope.deleting = false;
            }
        }
    }])
;